import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { changeRenderMediaDestination, getRenderMediaDestinations } from '../../actions/publish';
import { Button, Select } from '../../styled-components';
import { MainContent } from '../../styled-components/Layout';
import localize from '../../util/localizeUtils';
import { ButtonContainer, TabContentContainer, NoteMessage } from './styled-components';

class SaveMovieToDiskTabContent extends React.PureComponent {
  constructor(props) {
    super(props);
    props.initialize();
  }

  onChangeDestination = event => {
    this.props.onChangeDestination(event.target.value);
  }

  render() {
    return (
      <TabContentContainer>
        <MainContent>
          <div>
            <span style={{ paddingRight: '2rem' }}>{localize('presetLabel')}</span>
            <Select onChange={this.onChangeDestination}>
              {this.props.destinationList.map(d => (
                <option key={d.id} value={d.id} disabled={!d.isValid}>{d.name}{!d.isValid ? '*' : ''}</option>
              ))}
            </Select>
          </div>
          <NoteMessage visible={this.props.destinationList.length === 0}>
            {localize('renderMediaDestinationError')}
          </NoteMessage>
          <NoteMessage visible={this.props.destinationList.some(d => !d.isValid)}>
            {localize('presetUnavailableError')}
          </NoteMessage>
        </MainContent>
        <ButtonContainer paddingTop="8px">
          <Button onClick={this.props.onSave}>{localize('saveButton')}</Button>
        </ButtonContainer>
      </TabContentContainer>
    );
  }
}

SaveMovieToDiskTabContent.propTypes = {
  destinationList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired
  })).isRequired,
  initialize: PropTypes.func.isRequired,
  onChangeDestination: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  destinationList: state.publish.destinationList
});

const mapDispatchToProps = dispatch => ({
  initialize: () => dispatch(getRenderMediaDestinations()),
  onChangeDestination: (destinationId) => dispatch(changeRenderMediaDestination(destinationId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveMovieToDiskTabContent);



// WEBPACK FOOTER //
// ./app/components/RenderMediaDialog/SaveMovieToDiskTabContent.js